function onTouchstart (el) {
  const top = el.scrollTop
  const left = el.scrollLeft
  const totalScrollHeight = el.scrollHeight
  const totalScrollWidth = el.scrollWidth
  const currentScrollHeight = top + el.offsetHeight
  const currentScrollWidth = top + el.offsetWidth

  // If we're at the top or the bottom of the containers
  // scroll, push up or down one pixel.
  //
  // this prevents the scroll from "passing through" to
  // the body.
  if (top === 0) {
    el.scrollTop = 1
  } else if (currentScrollHeight === totalScrollHeight) {
    el.scrollTop = top - 1
  }

  if (left === 0) {
    el.scrollLeft = 1
  } else if (currentScrollWidth === totalScrollWidth) {
    el.scrollLeft = left - 1
  }
}

function onTouchmove (evt, el) {
  // if the content is actually scrollable, i.e. the content is long enough
  // that scrolling can occur
  if (el.offsetHeight < el.scrollHeight) {
    evt._isScroller = true
  }

  if (el.offsetWidth < el.scrollWidth) {
    evt._isScroller = true
  }
}

export default {
  bind: function (el) {
    el.addEventListener('touchstart', () => onTouchstart(el), { passive: true })

    el.addEventListener('touchmove', (evt) => onTouchmove(evt, el), { passive: true })
  },

  unbind: function (el) {
    el.removeEventListener('touchstart', () => onTouchstart(el), { passive: true })

    el.removeEventListener('touchmove', (evt) => onTouchmove(evt, el), { passive: true })
  }
}
